export default (state) => id => {
    return state.items.filter(i => {
        return i.WebReportId === id;
    })[0];
}